import { render } from "./authScreen.vue?vue&type=template&id=3c306344&scoped=true"
import script from "./authScreen.vue?vue&type=script&lang=js"
export * from "./authScreen.vue?vue&type=script&lang=js"

import "./authScreen.vue?vue&type=style&index=0&id=3c306344&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c306344"]])

export default __exports__